import { useEffect, useState } from "react";

export type AirlineListItem = {
  id: string;
  lcc: string;
  name: string;
  logo: string;
};

let airlineListCache: AirlineListItem[] | null = null;
let airlineListPromise: Promise<AirlineListItem[]> | null = null;

export function loadAirlineList() {
  if (airlineListCache) {
    return Promise.resolve(airlineListCache);
  }

  if (!airlineListPromise) {
    airlineListPromise = import("./airline-list").then((module) => {
      airlineListCache = module.airlineList;
      return airlineListCache;
    });
  }

  return airlineListPromise;
}

export function useAirlineList() {
  const [airlineList, setAirlineList] = useState<AirlineListItem[]>([]);

  useEffect(() => {
    void loadAirlineList().then(setAirlineList);
  }, []);

  return airlineList;
}
